import { useDispatch, useSelector } from 'react-redux';
import React, { useCallback } from 'react';
import { push } from 'connected-react-router';
import clsx from 'clsx';
import { Button } from '../../../../../components';
import useStyles from './styles';
import { selectProject } from '../../../../../store/modules/projects/selectors';
import RouteGetter from '../../../../../routes/RouteGetter';

type Props = {
};

const ViewDetailsButton = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const project = useSelector(selectProject);

  const onClickHandler = useCallback((e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    dispatch(push(RouteGetter.get('project').orders(project.data!.id)));
  }, [dispatch, project.data]);
  const isDevMode = process.env.REACT_APP_BUILD_ENV === 'development';
  return ( !isDevMode ? null : (
    <Button
      onClick={onClickHandler}
      variant="outlined"
      classes={{
        root: clsx(classes.button, {
          [classes.buttonPurchaseOutlined]: 'outlined',
        }),
        label: classes.buttonLabel,
      }}
    >
      View Details
    </Button>
  ));
};

export default ViewDetailsButton;
